import {t} from "i18next";
import ReactMarkdown from "react-markdown";
import {AssistantChannel, ChatAssistantMetadata} from "src/interfaces/assistant";
import Icon from "../Icon";

interface MessageProps {
  text: string;
  sender: "user" | "assistant";
  channel: AssistantChannel;
  metaData: ChatAssistantMetadata;
}

const Message = ({text, sender, channel, metaData}: MessageProps) => {
  return (
    <div
      className={`flex gap-2 items-center rounded-lg p-4 mt-4 w-fit text-gray-800 ${
        sender === "user" ? "ml-auto bg-red-100" : "mr-auto bg-slate-200"
      }`}
      style={{
        backgroundColor: sender === "user" ? metaData?.userMessageColor : metaData?.assistantMessageColor,
        color: sender === "user" ? metaData?.userMessageTextColor : metaData?.assistantMessageTextColor,
      }}
    >
      {sender === "assistant" &&
        (channel === AssistantChannel.CHAT && metaData?.avatarUrl ? (
          <img src={metaData.avatarUrl} alt="Assistant avatar" className="h-8 w-8 rounded-full mb-auto" />
        ) : channel === AssistantChannel.INSIGHTS ? (
          <div className="h-8 w-8 rounded-full mb-auto flex items-center justify-center bg-black">
            <Icon name="zap" iconSize="20px" color="white" />
          </div>
        ) : null)}
      <div className="w-fit">
        {sender === "user" && <p className="text-xs text-gray-500">{t("ASSISTANT_USER_NAME")}</p>}
        {sender === "assistant" && (
          <p className="text-xs text-gray-500">{metaData?.displayName || t("ASSISTANT_NAME")}</p>
        )}
        <ReactMarkdown>{text}</ReactMarkdown>
      </div>
    </div>
  );
};

export default Message;
